export default __webpack_public_path__ + "static/media/photo1.7bf50a94.jpg";